import { useEffect } from 'react';
import { useCurrentCompanyPref } from 'http-hooks/companypref/useCompanypref';
import useCompanyPreferences from './useCompanyPreferences';

const useInitializeApp = () => {
  const companyPrefs = useCompanyPreferences();
  const { setCompanyPreferences, companyPreferences } = companyPrefs;

  const {
    data: fetchedCompanyPrefs,
    isLoading: isLoadingPrefs,
    error: prefsError,
    isSuccess: isPrefsSuccess,
  } = useCurrentCompanyPref({
    staleTime: Infinity, // Never consider data stale once fetched
    refetchOnWindowFocus: false, // Don't refetch when window gains focus
    refetchOnReconnect: false, // Don't refetch when reconnecting
  });

  useEffect(() => {
    // Handle successful fetch
    if (isPrefsSuccess && fetchedCompanyPrefs) {
      setCompanyPreferences(fetchedCompanyPrefs);
    }
  }, [isPrefsSuccess, fetchedCompanyPrefs, setCompanyPreferences]);

  return {
    // Initialization status only
    isInitialized: !!companyPreferences,
    isLoading: isLoadingPrefs,
    error: prefsError,
  };
};

export default useInitializeApp; 